import { graphql } from "react-relay";

export const UpdateRoleAssignmentMutation = graphql`
  mutation UpdateRoleAssignmentMutation(
    $input: UpdateRoleAssignmentInput!
    $connections: [ID!]!
  ) {
    updateRoleAssignment(input: $input) {
      grant {
        errorMessage
        roleAssignment
          @appendNode(
            connections: $connections
            edgeTypeName: "RoleAssignmentEdge"
          ) {
          id
          principal {
            __typename
            roleAssignmentPrincipal
            ... on UserGroup {
              id
              name
              roleAssignments(first: 100) {
                edges {
                  node {
                    id
                    role {
                      id
                      name
                      permissions
                    }
                    target {
                      __typename
                      roleAssignmentTarget
                      ... on RoleScope {
                        displayName
                      }
                      ... on AccountGroup {
                        name
                      }
                      ... on PolicyCollection {
                        name
                      }
                      ... on RepositoryConfig {
                        name
                      }
                    }
                  }
                }
              }
            }
            ... on Node {
              id
            }
          }
          role {
            id
            name
            permissions
          }
          target {
            __typename
            roleAssignmentTarget
            ... on RoleScope {
              displayName
            }
            ... on AccountGroup {
              name
            }
            ... on PolicyCollection {
              name
            }
            ... on RepositoryConfig {
              name
            }
            ... on Node {
              id
            }
          }
        }
      }
      revoke {
        errorMessage
      }
    }
  }
`;
